import { takeEvery, all, put, select, call } from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors';
import * as settingsApi from '../api/settingsApi';
import { msalInstance } from '../webcommon/common/httpConnection/adfsConnection';

export function* AppConfigConnected(api) {
    try {
        const response = yield call(api.getAppConfig);
        if (response) {
            yield put(actions.setAppConfig(response));
        }
    } catch (_) {
        // non-403 errors are silently ignored; appConfig stays null
    }
}

export function* UserProfileConnected(api) {
    try {
        const initialised = yield select(selectors.getUserProfileInitialised);
        if (!initialised) {
            yield put(actions.setUserProfileLoading(true));
            const response = yield call(api.getUserRole);
            yield put(actions.setUserRole(response));
            const AadInfo = msalInstance.getAllAccounts()[0];
            const info = [{ email: AadInfo.username, userName: AadInfo.name }];
            yield put(actions.setUserInfo(info));
            yield put(actions.setUserProfileInitialised(true));
        }
    } finally {
        yield put(actions.setUserProfileLoading(false));
    }
}

export function* saveAppConfigSaga(api, action) {
    yield put(actions.setAppConfigSaving(true));
    yield put(actions.setAppConfigSaved(false));
    try {
        const response = yield call(api.updateAppConfig, action.data);
        if (response.status === 200) {
            yield put(actions.setAppConfig(response.data));
            yield put(actions.setAppConfigSaveError(null));
            yield put(actions.setAppConfigSaved(true));
        } else {
            // 207: saved but restart failed
            yield put(actions.setAppConfig(response.data));
            yield put(actions.setAppConfigSaveError(
                'Settings saved. WebJobs restart failed — please restart manually.'
            ));
        }
    } catch (err) {
        const message = err?.response?.data?.message || 'Failed to save settings.';
        yield put(actions.setAppConfigSaveError(message));
    } finally {
        yield put(actions.setAppConfigSaving(false));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.APP_CONFIG_LOADED, AppConfigConnected, settingsApi),
        takeEvery(actions.USER_PROFILE_LOADED, UserProfileConnected, settingsApi),
        takeEvery(actions.APP_CONFIG_SAVE_REQUESTED, saveAppConfigSaga, settingsApi)
    ]);
}
